module.exports = __webpack_public_path__ + "img/top-cleaning-bg.b7b351a.jpg";